
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-mail" })
export default class IconMail extends Vue {
  sData: string = require("@icon/feather/mail.svg");
}
